<template>
  <div class="review-plan__card">
    <div class="review-plan__card-icon d-flex mr-2">
      <i class="icon icon-cancel text-light-high"></i>
    </div>
    <div class="review-plan__card-content">
      <div class="review-plan__card-content-title heading-h5-16-medium mb-1">
        <slot name="title"></slot>
      </div>
      <div class="review-plan__card-content-desc">
        <slot name="description"></slot>
      </div>
      <div v-if="isCampaign" class="review-plan__card-message d-flex align-items-center mt-1">
        <div class="review-plan__card-message-icon mr-1">
          <i class="icon icon-warn-triangle"></i>
        </div>
        <span class="paragraph-12-regular">{{ $tc("downgrade.reviewPlan.campaign.warning") }}</span>
      </div>
      <div v-else-if="isUnpublish" class="review-plan__card-unpublish d-flex mt-3">
        <div class="review-plan__card-unpublish-content d-flex flex-column">
          <div class="review-plan__card-unpublish-content-title text-light-high">
            10 {{ $tc("newonboarding.welcome.option.ppage.title") }}
            <span class="review-plan__card-unpublish-content-title-publish-count">
              (<span class="review-plan__published-page" :class="{ 'review-plan__published-page-warn': isNeedToUnpublishProduct }">{{ publishedProductCount }}</span
              >/{{ limitPublishedProductPage }})
            </span>
          </div>
          <button :disabled="publishedProductCount == 0" class="btn btn-default px-3" :class="[isNeedToUnpublishProduct ? 'btn-danger2' : 'btn-secondary2', { 'disabled-light': publishedProductCount == 0 }]" @click="openUnpublishModal('productpages')">{{ $tc("downgrade.reviewPlan.unpublishProduct.text") }}</button>
        </div>
        <div class="review-plan__card-unpublish-divider mx-4"></div>
        <div class="review-plan__card-unpublish-content d-flex flex-column">
          <div class="review-plan__card-unpublish-content-title text-light-high">
            20 {{ $tc("onboarding.articlepages.title") }}
            <span class="review-plan__card-unpublish-content-title-publish-count">
              (<span class="review-plan__published-page" :class="{ 'review-plan__published-page-warn': isNeedToUnpublishArticle }">{{ publishedArticleCount }}</span
              >/{{ limitPublishedBlogPost }})
            </span>
          </div>
          <button class="btn btn-default px-3" :disabled="publishedArticleCount == 0" :class="[isNeedToUnpublishArticle ? 'btn-danger2' : 'btn-secondary2', { 'disabled-light': publishedArticleCount == 0 }]" @click="openUnpublishModal('articlepages')">{{ $tc("downgrade.reviewPlan.unpublishBlog.text") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { mutations } from "@/store/downgrade/types";
import unpublisStatus from "../mixins/unpublishStatus";

export default {
  name: "ReviewPlanCard",
  mixins: [unpublisStatus()],

  props: {
    isUnpublish: {
      type: Boolean,
      default: false
    },
    isCampaign: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo,
      instantShopId: state => state.instantShopId
    }),
    ...mapState("downgrade", {
      pages: state => state.pages,
      pagesPublishCount: state => state.pagesPublishCount
    }),
    limitPublishedProductPage() {
      const publishedText = this.$tc("generals.published").toLowerCase();
      return `${this.pages["productpages"].limit} ${publishedText}`;
    },
    limitPublishedBlogPost() {
      const publishedText = this.$tc("generals.published").toLowerCase();
      return `${this.pages["articlepages"].limit} ${publishedText}`;
    },
    shopVersion() {
      return (this && this.shopInfo && this.shopInfo.shopType) || window.___gemShopInfo.shopType || false;
    },

    publishedProductCount() {
      const { isGemPagesV6, isGemPagesV7, isGemPagesMixed } = this.shopVersion;

      if (isGemPagesV6) return this.shopInfo.publishedProductPagesCount;
      if (isGemPagesV7) return this.pagesPublishCount.publishedProductPagesCount;
      if (isGemPagesMixed) return this.pagesPublishCount.publishedProductPagesCount + this.shopInfo.publishedProductPagesCount;

      return 0;
    },
    publishedArticleCount() {
      const { isGemPagesV6, isGemPagesV7, isGemPagesMixed } = this.shopVersion;

      if (isGemPagesV6) return this.shopInfo.publishedArticlePagesCount;
      if (isGemPagesV7) return this.pagesPublishCount.publishedArticlePagesCount;
      if (isGemPagesMixed) return this.pagesPublishCount.publishedArticlePagesCount + this.shopInfo.publishedArticlePagesCount;

      return 0;
    }
  },
  watch: {
    instantShopId: function(val) {
      if (val) {
        if (this.isUnpublish) this.getPublishPageCount();
      }
    }
  },
  created() {
    if (this.isUnpublish && this.instantShopId) this.getPublishPageCount();
  },
  methods: {
    ...mapMutations("downgrade", {
      openUnpublishModal: mutations.OPEN_UNPUBLISH_MODAL
    }),
    ...mapActions("downgrade", {
      getPublishPageCount: "getPublishPageCount"
    })
  }
};
</script>

<style lang="scss" scoped>
.review-plan {
  &__published-page-warn {
    color: $accentRed300;
  }
  &__card {
    max-width: 830px;
    border-radius: 3px;
    padding: 24px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    border: solid 1px $neutral7;
    margin-bottom: 24px;
    &-unpublish {
      margin-top: 12px;
      .btn {
        width: fit-content !important;
        min-height: 32px !important;
        font-size: 14px !important;
      }
      &-content-title {
        margin-bottom: 12px;
        font-weight: 500;
      }
      &-content-title-publish-count {
        font-weight: 400 !important;
        color: $dark6 !important;
      }
      &-divider {
        border-right: solid 1px $neutral7;
        align-self: stretch;
      }
    }
    &-icon {
      width: 20px;
      height: 24px;
      @include flex-center;
      margin-right: 12px;
      .icon {
        color: $accentRed300;
      }
    }
    &-content {
      display: flex;
      flex-direction: column;
      &-title {
        color: $textLightModeHigh !important;
      }
      &-desc {
        color: $dark6;
      }
    }
    &-message {
      color: $accentAmber500;
      &-icon {
        height: 18px;
        font-size: 16px;
      }
    }
  }
}
</style>
